import React, { useState } from 'react';
import './App.css';
import Countdown from 'react-countdown';
import ImageCarousel from './ImageCarouselComponent';
import ReCaptchaComponent from './ReCaptchaComponent';
import emailjs from 'emailjs-com';

function App() {
  const images = Array.from({ length: 113 }, (_, i) => `${process.env.PUBLIC_URL}/photos/5TOCONGRESO-${(i + 1).toString().padStart(3, '0')}.jpg`).sort(()=>Math.random()-0.5);
  const [captchaValue, setCaptchaValue] = useState<string | null>(null);
  const [inscription, setInscription] = useState<any>({});
  const renderer = ({ days, hours, minutes, seconds, completed }: any) => {
    if (completed) {
      return <span>¡El tiempo ha terminado!</span>;
    } else {
      return (
        <p className='remaining-time'>
          <div className="value">
            <span>{days}</span>
            <span>días</span>
          </div>
          <div className="value">
            <span>{hours}</span>
            <span>horas</span>
          </div>
          <div className="value">
            <span>{minutes}</span>
            <span>minutos</span>
          </div>
          <div className="value">
            <span>{seconds}</span>
            <span>segundos</span>
          </div>
        </p>
      );
    }
  };
  const sendInformation=()=>{
    const requiredFields = [ "nombre", "email", "telefono", "ciudad", "pais", "especialidad", "perfil", "cedula", "inscripciones" ];

  for (const field of requiredFields) {
    const value = inscription[field];

    if (typeof value === "string" && value.trim() === "" || value === undefined || value === null) {
      alert(`Por favor completa el campo: ${field}`);
      return;
    }

    if (Array.isArray(value) && value.length === 0) {
      alert("Selecciona al menos una opción en '¿A qué te inscribes?'");
      return;
    }
  }
    //console.log(inscription)
    //return;
    
    emailjs.send('service_msqpjqh', 'template_wgmkmd8', inscription, 'kMs7ctxW9dRqu8ZAJ').then(_ => alert("Informacion enviada")).catch(error => console.error("Error al enviar correo:", error));
  }
  const editInscription = (name: string, value: string | boolean) => {
    setInscription((prev:any) => {
      if (typeof value === 'boolean') {
        const prevArray = prev.inscripciones || [];
        const updatedArray = value
          ? [...prevArray, name]
          : prevArray.filter((item:any) => item !== name);

        return { ...prev, inscripciones: updatedArray };
      } else {
        return { ...prev, [name]: value };
      }
    });
  };
  const openWhatsApp = async() => {
        const message = "Hola, ¡Quisiera Información acerca del 6to. Congreso Internacional!"; 
        const whatsappURL = `https://wa.me/+5213310824629?text=${message}`;
        window.open(whatsappURL, '_blank');
    }
  return (
    
      <main>
        <section className='header'>
          <div className="image-container">
            <img src={process.env.PUBLIC_URL + "/$pwo57mecl3.jpeg"} alt="" />
          </div>
          
          <div className="info">
            <div className="congreso">
              <div className="data">
                <h1>Pre-Congreso</h1>
                <span>29 de enero 2026</span>
                <p>{"El 29 de enero se impartirán talleres teórico-prácticos dirigidos a médicos especialistas y residentes en ginecología, medicina fetal y cirugía fetal. \nIncluye práctica en simuladores y evaluación de habilidades."}</p>
              </div>
              <div className="data">
                <h1>Congreso</h1>
                <span>30 enero y 1, 2 febrero 2026</span>
                <p>{"Un espacio de actualización científica, formación académica y colaboración internacional, donde los principales expertos en medicina fetal y cirugía intrauterina se reúnen para compartir avances, casos clínicos y nuevas tecnologías."}</p>
              </div>
            </div>
            
            <div className="remaining-time"> 
              <Countdown date={new Date(2026, 0, 29)} renderer={renderer}/>
            </div>
            <input type="button" value="Descarga el programa" />
          </div>
        </section>
        <section className="location">
          <div className="data">
            <span>Sede del evento</span>
            <h1>Hospital Español</h1>
            <span>
              Av. Ejército Nacional Mexicano #613, Granada, Miguel Hidalgo, 11520 CDMX
            </span>
            <div className="map">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d235.14967506256073!2d-99.19566461570666!3d19.438537877722563!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d20205bada1ae5%3A0xc2adfddebbf7722b!2sHospital%20Espa%C3%B1ol!5e0!3m2!1ses-419!2sus!4v1753300339788!5m2!1ses-419!2sus" width="1000" height="450"></iframe>
            </div>  
          </div>
          <div className="hotels">
            <h3>Hoteles cerca</h3>
            <span>Recuerda que el hospedaje no está incluido. Cada participante es responsable de gestionar y cubrir su reservación de hotel.</span>
          </div>
        </section>
        <section className="prices">
          <img src={process.env.PUBLIC_URL + "/costos.jpg"} alt="" />
        </section>
        <section className="form">
          <div className="content">
            <h2>¡Inscríbete ahora!</h2>
            <h3>No pierdas tu lugar en el congreso más esperado del 2026.</h3>
            <div>
              <div className="field">
                <span>Nombre*</span>
                <input type="text" name="nombre" onChange={(e)=>{editInscription(e.target.name, e.target.value)}}/>
              </div>
              <div className="horizontal">
                <div className="field">
                  <span>Email*</span>
                  <input type="text" name="email" onChange={(e)=>{editInscription(e.target.name, e.target.value)}}/>
                </div>
                <div className="field">
                  <span>Teléfono Celular*</span>
                  <input type="text" name="telefono" onChange={(e)=>{editInscription(e.target.name, e.target.value)}}/>
                </div>
              </div>
              <div className="horizontal">
                <div className="field">
                  <span>Ciudad*</span>
                  <input type="text" name="ciudad" onChange={(e)=>{editInscription(e.target.name, e.target.value)}}/>
                </div>
                <div className="field">
                  <span>Pais*</span>
                  <input type="text" name="pais" onChange={(e)=>{editInscription(e.target.name, e.target.value)}}/>
                </div>
              </div>
              <div className="horizontal">
                <div className="field">
                  <span>Especialidad Médica*</span>
                  <input type="text" name="especialidad" onChange={(e)=>{editInscription(e.target.name, e.target.value)}}/>
                </div>
                <div className="field">
                  <span>Perfil*</span>
                  <select name="perfil" defaultValue="" onChange={(e)=>{editInscription(e.target.name, e.target.value)}}>
                    <option value="" disabled>Selecciona</option>
                    <option value="Congresista">Congresista</option>
                    <option value="Residente">Residente</option>
                  </select>
                </div>
              </div>
              
              <div className="field">
                <span>No. Cédula Profesional (Médico General)*</span>
                <input type="text" name="cedula" onChange={(e)=>{editInscription(e.target.name, e.target.value)}}/>
                <label htmlFor="">Verificar que no haya errores. Al enviarse, no podrá modificarse.</label>
              </div>
              <div className="field">
                <span>¿A que te inscribes?*</span>
                <div className="container">
                  <fieldset>
                    <input type="checkbox" name="Congreso" id="Congreso" onChange={(e) => editInscription(e.target.name, e.target.checked)}/>
                    <label htmlFor="Congreso">Congreso</label>
                  </fieldset>
                  <fieldset>
                    <input type="checkbox" name="Talleres" id="Talleres" onChange={(e) => editInscription(e.target.name, e.target.checked)}/>
                    <label htmlFor="Talleres">Talleres</label>
                  </fieldset>
                  <fieldset>
                    <input type="checkbox" name="Pre-Congreso" id="Pre-Congreso" onChange={(e) => editInscription(e.target.name, e.target.checked)}/>
                    <label htmlFor="Pre-Congreso">Pre Congreso</label>
                  </fieldset>
                </div>
              </div>
              <div className='captcha'>
                <ReCaptchaComponent onChange={setCaptchaValue} />
              </div>
            </div>
            <input type="button" value="Enviar Inscripción" disabled = {!captchaValue} onClick={sendInformation}/>
          </div>    
        </section>
        <section className="organization">
          <h1>Organiza</h1>
          <img className="logo" src={process.env.PUBLIC_URL + "/$m7fy9k1cki8.png"} alt="" />
          <img className='decotarion' src={process.env.PUBLIC_URL + "/$oq55m9c627o.png"} alt="" />
          
        </section>
        <section className="gallery">
            <h1 className="text-2xl mb-4">Edición anterior</h1>
            <ImageCarousel images={images} />
        </section>
        <section className="footer">
          <a href="https://www.facebook.com/medicinafetalmexico.educacion/" target='_blank'><img src={process.env.PUBLIC_URL + "/facebook_circle_dark.svg"} /></a>
          <a href="https://www.instagram.com/mfm.education/" target='_blank'><img src={process.env.PUBLIC_URL + "/instagram_circle_dark.svg"} /></a>
        </section>
        <div className={"floating"}>
          <img src={process.env.PUBLIC_URL + "/WhatsApp.svg.webp"} alt="" onClick={openWhatsApp} />
        </div>
      
      </main>
    
  );
}

export default App;
